import React, { useEffect, useState } from 'react'
import './experience.css'
import { getPortfolioConfig } from '../../firebase'

const Experience = () => {
  const [experiences, setExperiences] = useState([])

  useEffect(() => {
    let isMounted = true

    const loadExperience = async () => {
      const { experiences: remoteExperiences } = await getPortfolioConfig()

      if (isMounted) {
        setExperiences(remoteExperiences)
      }
    }

    loadExperience()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <section id="experience" className='card-container'>
      <h5>My Career Journey</h5>
      <h2>Experience</h2>

      <div className="container experience__container">
        <div className="experience__timeline">
          {experiences.length > 0 ? experiences.map((exp, index) => (
            <div key={exp.id || index} className="experience__item">
              <div className="experience__marker"></div>

              <div className="experience__content">
                <div className="experience__header">
                  <div className="experience__title-section">
                    <h3>{exp.position}</h3>
                    <p className="experience__company">{exp.company}</p>
                  </div>
                  <div className="experience__meta">
                    <span className="experience__period">{exp.period}</span>
                    <span className="experience__location">{exp.location}</span>
                  </div>
                </div>

                <ul className="experience__achievements">
                  {(Array.isArray(exp.achievements) ? exp.achievements : []).map((achievement, idx) => (
                    <li key={idx}>{achievement}</li>
                  ))}
                </ul>
              </div>
            </div>
          )) : (
            <p className="text-light">Experience data is loading...</p>
          )}
        </div>
      </div>
      <p className="experience__scroll-hint" aria-hidden="true">Swipe to explore experience <span>→</span></p>
    </section>
  )
}

export default Experience